import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getApi } from "../../../api/api";
import {
  PublicStoreInterface,
  PublicVacancyInterface,
} from "../../../common/types/interfaces";
import {
  selectClusterList,
  selectClusterListLoading,
} from "../../../store/slices/clusterListSlice";

export const useStoreDetails = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const clusterId = searchParams.get("cluster");

  const clusters = useSelector(selectClusterList);
  const clustersLoading = useSelector(selectClusterListLoading);

  const [store, setStore] = useState<PublicStoreInterface | null>(null);
  const [loading, setLoading] = useState(true);
  const [vacancies, setVacancies] = useState<PublicVacancyInterface[]>([]);

  useEffect(() => {
    if (!id || clustersLoading) return;

    let cancelled = false;
    setLoading(true);

    getApi()
      .getStore(Number(id), "logmall")
      .then((data) => {
        if (cancelled) return;
        setStore(data);
      })
      .catch(() => {
        if (cancelled) return;
        setStore(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id, clustersLoading]);

  const cluster = clusters.find((c) => c.id === store?.clusterId) || null;

  return {
    store,
    cluster,
    ready: !clustersLoading && !loading && Boolean(store),
    vacancies,
  };
};
